import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { configurationOntologyForAutomaticProtocolService } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-ontology-for-automatic-protocol/configuration-ontology-for-automatic-protocol.service'
import { ConfigurationOntologyForAutomaticProtocolResponse } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-ontology-for-automatic-protocol/configuration-ontology-for-automatic-protocol.dto'
import { store } from '@/store/store'

export const columnsDefAutomationProtocolsGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            field: 'sampleType.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.topographicCode'),
            field: 'topographicCode.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            field: 'procedure.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            field: 'mostLikelyMorphologicCode.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationAutomationProtocolsGridState extends CrudModelPaginatorLaboratory<ConfigurationOntologyForAutomaticProtocolResponse> {
    service: typeof configurationOntologyForAutomaticProtocolService
    laboratoryId: number
}
export const initialConfigurationAutomationProtocolsGridState =
    (): ConfigurationAutomationProtocolsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.protocol',
        columnsDef: columnsDefAutomationProtocolsGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationOntologyForAutomaticProtocolService, store.getters.labId),
        service: configurationOntologyForAutomaticProtocolService,
        laboratoryId: store.getters.labId
    })
